// T-150 (v1.8.44, Session 40, 30.09.2026, Kundin-Mail 30.09. 19:50 Punkt 1 und 13 bis 15): Gutschein stornieren auch, wenn er
// noch nicht bezahlt ist (Status PendingPayment), Grund mindestens 3 Zeichen wie bei Buchungen (T-138).
// Backend: Business.Zahlung.GutscheinStorno (PricingTests), CancelVoucherDto MinimumLength 3.

export const MIN_GRUND_GUTSCHEIN = 3;

/** Menüpunkt "Stornieren" anzeigen (bisher nur Active). */
export function gutscheinStornierbar(status: string | null | undefined): boolean {
  return status === 'Active' || status === 'PendingPayment';
}

/** Hinweise im Storno-Dialog je nach Zahlungsstand. */
export function stornoHinweise(status: string | null | undefined, payPalInPruefung?: boolean): string[] {
  const hinweise: string[] = [];
  if (status === 'PendingPayment') {
    hinweise.push('Der Gutschein ist noch nicht bezahlt. Die offene Gutschein-Rechnung wird mitstorniert, eine offene Kartenzahlung verfällt, eine PayPal-Zahlung wird danach nicht mehr angenommen. Der Käufer wird nicht automatisch informiert; geht eine Überweisung doch noch ein, bitte zurückzahlen.');
    if (payPalInPruefung) {
      hinweise.push('Achtung: PayPal prüft eine Zahlung zu diesem Gutschein. Bitte nur stornieren, wenn PayPal die Zahlung abgelehnt hat; geht das Geld doch ein, muss es im PayPal-Konto erstattet werden.');
    }
  } else if (status === 'Active') {
    hinweise.push('Der Gutschein ist bezahlt. Eine Erstattung lösen Sie wie bisher selbst aus (Überweisung, Stripe-Dashboard bzw. PayPal-Konto).');
  }
  return hinweise;
}

export function grundAusreichend(grund: string): boolean {
  return grund.trim().length >= MIN_GRUND_GUTSCHEIN;
}
